import { API_URL } from '@/constants';

type CoinbaseAnswer = {
  address: string;
  url: string;
};

export const getCoinbaseLink = async (
  address: string,
): Promise<CoinbaseAnswer | undefined> => {
  try {
    const response = await fetch(
      `${API_URL}/integrations/coinbase-link?address=${address}`,
    );
    return await response.json();
  } catch (e) {
    console.error('Coinbase request error');
  }
};
